export default function setRelationalSize({ props, state }) {
  const { name, path, orderItemId } = props
  let relationalPath = path
  const { ratio } = state.get(`basket.basketItems.${orderItemId}`)
  const unit = state.get('basket.unit')

  const format = (value, ratio) => {
    if (unit === 'px') {
      return Math.round(value * ratio)
    }
    return (value * ratio).toFixed(2)
  }

  let size = format(props.value, ratio.width)
  if (name === 'width') {
    relationalPath = `${relationalPath}.form.height`
    size = format(props.value, ratio.height)
  } else {
    relationalPath = `${relationalPath}.form.width`
  }

  state.set(`${relationalPath}.value`, size)
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/setRelationalSize.js